import { useEffect, useState } from "react";

const navItems = [
  { href: "#lead", label: "头版头条" },
  { href: "#dujia", label: "独家猛料" },
  { href: "#star", label: "明星网红" },
  { href: "#secret", label: "行业秘密" },
  { href: "#rebang", label: "猛料热榜" },
  { href: "#faq", label: "追更说明" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 border-b ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-background-200"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a href="#lead" className="flex items-center gap-2 cursor-pointer shrink-0">
            <span className="relative flex items-center justify-center w-9 h-9 rounded-lg bg-primary-600 text-background-50 font-heading font-bold text-lg">
              黑
              <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-accent-500 animate-blink" />
            </span>
            <span className="leading-none">
              <span className="block font-heading text-xl font-extrabold tracking-tight text-foreground-950">
                每日黑料
              </span>
              <span className="block text-[10px] font-semibold tracking-[0.22em] text-primary-600 mt-1">
                独家曝光 · 实时更新
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {it.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden md:inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700 whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-blink" />
              正在直播吃瓜中
            </span>
            <a
              href="#faq"
              className="hidden sm:inline-flex items-center whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              订阅追更
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md text-foreground-900 hover:bg-secondary-100 cursor-pointer"
            >
              <i className={`ri-${open ? "close" : "menu"}-line w-6 h-6 flex items-center justify-center`} />
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100 cursor-pointer"
              >
                {it.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}